import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";

import { useCreateField } from "../../hooks/createField.hook";
// import { createField, addShips } from "../battle/playerSlice";
import { playerActions } from "../battle/playerSlice";
import { computerActions } from "../battle/computerSlice";

import Cell from "../cell/Cell";
import Button from "../button/Button";
import grid from '../../assets/grid.png';

const Wrapper = styled.div`
    width: 850px;
    padding: 30px;
    margin: 30px auto;
    border-radius: 50px;
    background: linear-gradient(145deg, #cacaca, #f0f0f0);
    box-shadow:  10px 10px 30px #bebebe, -10px -10px 30px #ffffff;
`;

const Flex = styled.div`
    display: flex;
    flex-direction: ${props => props.column ? 'column' : 'row'};
    justify-content: space-around;
    align-items: space-around;
`;

const Title = styled.h1`
    font-size: 300%;
    text-align: center;
    text-shadow: -7px 7px 14px #757575,
        7px -7px 14px #ffffff;
`;

const appear = keyframes`
    from {
        opacity: 0;
        transform: blur(50px);
    }
    to {
        opacity: 1;
        transform: blur(0);
    }
`;

const StyledField = styled.div`
    display: grid;
    width: 332px;
    height: 332px;
    border-radius: 5px;
    box-shadow: inset 6px 6px 10px 0 rgba(0, 0, 0, 0.2),
        inset -6px -6px 10px 0 rgba(255, 255, 255, 0.5);
    grid-template-columns: repeat(10, 33px);
    background: url('${grid}') repeat;
    animation: ${appear} 1s ease;
`;

const NewGame = () => {

    const dispatch = useDispatch();
    // const { generatedField, allShips } = useCreateField();
    const player = useCreateField();
    const computer = useCreateField();

    const startNewGame = () => {
        dispatch(playerActions.createField(player.generatedField));
        dispatch(playerActions.addShips(player.allShips));
        dispatch(computerActions.createField(computer.generatedField));
        dispatch(computerActions.addShips(computer.allShips));
    }

    const renderField = arr => {
        
        return arr.map(({id, ...props}) => {
            return (
                <Cell key={id} id={id} fieldOwner={'player'} {...props} />
            );
        });
    }

    const cells = renderField(player.generatedField);

    return (
        <>
            <Wrapper>
                <Title>
                    Welcome to the Sea Battle game!
                </Title>
            </Wrapper>
            <Wrapper>
                <Flex>
                    <StyledField owner={'player'}>
                        {cells}
                    </StyledField>
                    <Flex column>
                        <Button>
                            Change ships position
                        </Button>
                        <Link to="/game" onClick={startNewGame}>
                            <Button>
                                Let's play the game
                            </Button>
                        </Link>
                    </Flex>
                </Flex>
            </Wrapper>
        </>
        
    );
}

export default NewGame;